import React, { useState } from "react";
import styles from "./RoundedTabs.module.scss";
import CounterBadge from "../controls/counterBadge/CounterBadge";
import { useDispatch } from "react-redux";
import { getReminders } from "../../store/actions/general.actions";

const RoundedTabs = ({ tabs, panels, panelStyle }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const dispatch = useDispatch();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(getReminders());
  };

  return (
    <div className={styles.tabs_container}>
      <div className={styles.tabs}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`${styles.tab_button} ${
              tab.label === activeTab ? styles.active : ""
            }`}
            onClick={() => handleTabClick(tab.label)}
          >
            {tab.label}
            <CounterBadge
              StyleClass="CounterBadgeWrap_small"
              BadgeSize="medium"
              count={tab.count}
            />
          </button>
        ))}
      </div>
      <div className={panelStyle}>{panels[activeTab]}</div>
    </div>
  );
};

export default RoundedTabs;
